import React, { useContext, useState } from "react";

// Styles
import "../../../assets/css/MultimediaChat.css";

// Components
import Spinner from "../../Spinners/Spinner";
import ModalPreviewMedia from "../../modals/ModalPreviewMedia";

// Context
import { ChatContext } from "../../../context/chat/ChatContext";
import { useGetDta } from "../../../hooks/useGetDta";

const baseURL = process.env.REACT_APP_API;

/**
 * Pestaña de multimedia de chat
 *
 * @returns {JSX.Element} Componente de react
 */
const MultimediaTab = () => {
  const [show, setShow] = useState(false); // Modal de vista previa
  const [selectedItem, setSelectedItem] = useState(null); // Elemento seleccionado

  // Contexto de chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  // Obtener multimedia del chat
  const { loading, data } = useGetDta(
    `sms/multimedia`,
    {
      id: activeChat.id_user || activeChat.id,
    },
    "POST"
  );

  /**
   * Manejar clic en elemento para mostrar vista previa
   *
   * @param {Object} item - Elemento seleccionado
   * @returns {void}
   */
  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShow(true);
  };

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner />
      </div>
    );

  return (
    <>
      <div className="multimedia-grid">
        {data.map((item, key) => (
          <div
            key={key}
            className="cursor-pointer item"
            onClick={() => handleItemClick(item)}
          >
            {item.type === "image" ? (
              <img
                src={`${baseURL}/${item.object}`}
                alt="multimedia"
                className="rounded"
              />
            ) : item.type === "video" ? (
              <video
                controls
                src={`${baseURL}/${item.object}`}
                alt="video"
                className="rounded"
              />
            ) : null}
          </div>
        ))}
      </div>

      {/* Modal de vista previa */}
      {selectedItem && (
        <ModalPreviewMedia
          show={show}
          handleClose={() => setShow(false)}
          type={selectedItem.type}
          src={`${baseURL}/${selectedItem.object}`}
        />
      )}
    </>
  );
};

export default MultimediaTab;
